export const SORT_TYPES = {
  text: { asc: 'A → Z', desc: 'Z → A' },
  date: { asc: 'Earliest → Latest', desc: 'Latest → Earliest' },
  number: { asc: '1 → 9', desc: '9 → 1' },
};

export const HOLDS_COLUMNS = [
  { id: 'title', label: 'Title', alwaysVisible: false, defaultVisible: true, sortable: true, sortType: 'text' },
  { id: 'venue_name', label: 'Venue', alwaysVisible: false, defaultVisible: true, sortable: true, sortType: 'text' },
  { id: 'event_date', label: 'Event Date', alwaysVisible: false, defaultVisible: true, sortable: true, sortType: 'date' },
  { id: 'artists', label: 'Artists', alwaysVisible: false, defaultVisible: true, sortable: false },
  { id: 'hold_positions', label: 'Dates', alwaysVisible: false, defaultVisible: true, sortable: false },
  { id: 'created_at', label: 'Created', alwaysVisible: false, defaultVisible: true, sortable: true, sortType: 'date' },
  { id: 'converted', label: 'Converted', alwaysVisible: false, defaultVisible: true, sortable: true, sortType: 'text' },
];

export const getDefaultVisibleColumns = () =>
  HOLDS_COLUMNS.filter(c => c.defaultVisible);

export const getDefaultHiddenColumns = () =>
  HOLDS_COLUMNS.filter(c => !c.defaultVisible && !c.alwaysVisible);
